<template>
  <div class="operation-report-delete-button">
    <vs-button
      class="delete-button cursor-pointer"
      :color="AISEA_COLOR.BLUE"
      type="border"
      style="padding: 5px 14px;"
      @click="onClick"
    >
      <div class="flex justify-center items-center col-gap-2">
        <delete-icon />
      </div>
    </vs-button>
  </div>
</template>

<script>
import ColorMixin from "@/mixins/ColorMixin.js";
import DeleteIcon from "@/views/enterprise/addon/operation/components/icons/DeleteIcon";
const EVENTS = {
  CLICK: "click",
};

export default {
  name: "OperationReportDeleteButton",
  mixins: [ColorMixin],
  components: { DeleteIcon },
  methods: {
    onClick() {
      this.$emit(EVENTS.CLICK);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";

.operation-report-delete-button {
  ::v-deep .delete-button {
    width: 50px;
    height: 50px;
    border-radius: 4px;
    border: 1px solid $aisea-blue;

    .vs-button-backgroundx.vs-button--background {
      display: none; // ボタンクリックした時に、背景色が変わるのを防ぐ
    }
  }
}
</style>
